import React, { forwardRef } from 'react';
import BaseSelect from '../base-select';
import { AUTOCOMPLETE_PROPS } from './types';
import noop from '../../../utils/noop';
import { SIZES } from '../base-select/constants';

const defaultOptions = [];

const Autocomplete = forwardRef((props, ref) => {
  const {
    clearable = true,
    defaultInputValue = '',
    inputValue = null,
    disabled = false,
    blurInputOnSelect = false,
    captureMenuScroll = false,
    id = null,
    invalid = false,
    asyncConfig = null,
    name = null,
    onBlur = noop,
    onCreateOption = null,
    filterOptionsFunction = null,
    onFocus = noop,
    onInputChange = noop,
    onKeyDown = noop,
    options = defaultOptions,
    placeholder = 'Select item',
    preventOverflow = false,
    size = SIZES.small,
    transparent = false,
    iconComponent = null,
    prefixTextComponent = null,
    defaultMenuIsOpen = false,
    autoFocus = false,
    openMenuOnFocus = false,
    menuIsOpen = null,
    noResultsText = null,
    maxMenuHeight = null,
    menuWidth = '',
    shouldMarkSelectedOption = false,
    withDropdownIndicator = false,
    onChange,
  } = props;

  return (
    <BaseSelect
      appearance="autocomplete"
      clearable={clearable}
      disabled={disabled}
      id={id}
      invalid={invalid}
      name={name}
      defaultInputValue={defaultInputValue}
      inputValue={inputValue}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onChange={onChange}
      onCreateOption={onCreateOption}
      filterOptionsFunction={filterOptionsFunction}
      onFocus={onFocus}
      onInputChange={onInputChange}
      options={options}
      placeholder={placeholder}
      preventOverflow={preventOverflow}
      size={size}
      blurInputOnSelect={blurInputOnSelect}
      captureMenuScroll={captureMenuScroll}
      asyncConfig={asyncConfig}
      transparent={transparent}
      iconComponent={iconComponent}
      prefixTextComponent={prefixTextComponent}
      defaultMenuIsOpen={defaultMenuIsOpen}
      autoFocus={autoFocus}
      openMenuOnFocus={openMenuOnFocus}
      menuIsOpen={menuIsOpen}
      maxMenuHeight={maxMenuHeight}
      menuWidth={menuWidth}
      noResultsText={noResultsText}
      shouldMarkSelectedOption={shouldMarkSelectedOption}
      ref={ref}
      withDropdownIndicator={withDropdownIndicator}
    />
  );
});

Autocomplete.displayName = 'Autocomplete';
Autocomplete.propTypes = AUTOCOMPLETE_PROPS;

export default Autocomplete;
